import styles from './CalendarErrorPopup.module.css';

interface Props {
  text: string;
  onClose: () => void;
}

export const CalendarErrorPopup = ({ text, onClose }: Props) => {
  return (
    <div className={styles['err']}>
      <div className={styles['err__overlay']}></div>
      <div className={styles['err__content']}>
        <p className={styles['err__content__txt']}>{text}</p>
        <a className={styles['err__content__btn']} onClick={onClose}>
          OK
        </a>
      </div>
    </div>
  );
};
